import type { App } from 'vue'
import { createI18n } from 'vue-i18n'
import { cookieRef } from '@layouts/stores/config'
import { themeConfig } from '@themeConfig'

const messages = Object.fromEntries(
  Object.entries(
    import.meta.glob<{ default: any }>('./locales/*.json', { eager: true }))
    .map(([key, value]) => [key.slice(10, -5), value.default]),
)

let _i18n: any = null

function replaceLocaleMessages(
  locale: string,
  localeModule?: unknown,
) {
  const localeMessages = (localeModule as { default?: any } | undefined)?.default

  if (!localeMessages)
    return

  messages[locale] = localeMessages
  _i18n?.global.setLocaleMessage(locale, localeMessages)
}

export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: cookieRef('language', themeConfig.app.i18n.defaultLocale).value,
      fallbackLocale: 'en',
      messages,
    })
  }

  return _i18n
}

export default function (app: App) {
  app.use(getI18n())
}

// Locale JSON is eagerly read only when this module is first evaluated. During
// development, Vue components hot-reload independently while the singleton
// i18n instance survives, so newly added keys otherwise render literally until
// a full page refresh. Refresh the live global catalogs when either supported
// locale changes to keep component code and translations in the same HMR state.
if (import.meta.hot) {
  import.meta.hot.accept(
    ['./locales/en.json', './locales/ar.json'],
    ([enModule, arModule]) => {
      replaceLocaleMessages('en', enModule)
      replaceLocaleMessages('ar', arModule)
    },
  )
}
